import type { ZodIssue } from 'zod'
import { useFormContext } from './form'

export const useGetError = (path: string): null | ZodIssue => {
  const context = useFormContext()

  if (context?.errors) {
    const error = (context.errors as ZodIssue[]).find((item) => (item?.path || []).includes(path))

    return error || null
  }

  return null
}
